// Libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Container } from 'react-bootstrap';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import InstructorService from 'services/InstructorService';

// Components
import Loader from 'components/common/Loader';
import PageHeader from 'components/common/PageHeader';

//-------------------------------------------------------------------------------------------------------------------

class ReferralCodesPage extends React.Component {

    constructor(props) {
        super(props);

        this.editReferralCodeModalRef = React.createRef();

        this.state = {
            isLoading: true
        };
    }

    async componentDidMount() {
        window.scrollTo(0, 0);
        this.load();
    }

    async load() {
        GlobalStateService.setValues({
            area: 'referral-codes'
        });
        const referralCodes = await InstructorService.listReferralCodes();
        this.setState({
            referralCodes,
            isLoading: false
        });
    }

    async editReferralCode(course) {
        await this.editReferralCodeModalRef.current.show({
            courseID: course.id
        });
        this.load();
    }

    async addReferralCode() {
        await this.editReferralCodeModalRef.current.show({
        });
        this.load();
    }

    render() {
        return (<>
            <div className="page referral-codes-page">

                <PageHeader>
                    <h1>Referral Codes</h1>
                </PageHeader>

                <main>

                    <Container>

                        <section>

                            {this.renderInner()}

                        </section>

                    </Container>

                </main>

            </div>

        </>);
    }

    renderInner() {
        const {
            isLoading,
            referralCodes
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        return (

            <div className="sticky-table-container scrolling">

                <table className="table table-bordered sticky-table selectable referral-codes-table">
                    <thead>
                        <tr>
                            <th>Created by</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {referralCodes.map(rc =>
                            <tr key={rc.id} onClick={e => this.editReferralCode(rc)}>
                                <td>
                                    {rc.sourceInstructor && <>
                                        {rc.sourceInstructor.firstName} {rc.sourceInstructor.lastName}
                                    </>}
                                </td>
                                <td>{rc.firstName}</td>
                                <td>{rc.lastName}</td>
                                <td>{rc.email}</td>
                                <td>{this.renderStatus(rc)}</td>
                            </tr>
                        )}
                    </tbody>
                    {referralCodes.length == 0 &&
                        <tfoot>
                            <tr>
                                <td colSpan="5" className="empty-text">
                                    No referral codes generated
                                </td>
                            </tr>
                        </tfoot>
                    }
                </table>

            </div>

        );
    }

    renderStatus(referralCode) {
        if (referralCode.dateConverted) {
            return 'Used';
        }
        return 'Not used';
    }
}

export default withRouter(ReferralCodesPage);